import { SettingRole } from "features/Setting"

export const SettingRolePages = () => {
    return (
        <SettingRole />
    )
}